<template>
  <v-edit-dialog
    v-on="$listeners"
    :return-value="theValue"
    @save="save"
    @cancel="cancel"
    @open="open"
    large
  >
    <v-btn text class="px-0">{{ value }}</v-btn>
    <template v-slot:input>
      <AdminInputStockStepper
        :value="theValue"
        :min="min"
        :max="max"
        @update="stepperValue = $event"
        @update:delta="delta = $event"
      />
    </template>
  </v-edit-dialog>
</template>

<script>
import AdminInputStockStepper from '@/components/AdminInputStockStepper'
import { Model } from '@vuex-orm/core'
import _get from 'lodash/get'
export default {
  name: 'AdminCellDialogStockStepper',
  inject: {
    cancel: { default: null },
    open: { default: null },
  },
  components: {
    AdminInputStockStepper,
  },
  props: {
    value: {
      type: [String, Number],
      default: null,
    },
    width: {
      type: [String, Number],
      default: null,
    },
    Model: {
      type: Model,
      default: () => Model,
    },
    fieldName: {
      type: String,
      require: true,
    },
    deltaFieldName: {
      type: String,
      default: 'stock_delta',
    },
    id: {
      type: [String, Number],
      require: true,
    },
    min: {
      type: [String, Number],
      default: null,
    },
    max: {
      type: [String, Number],
      default: null,
    },
  },
  data() {
    return {
      stepperValue: this.value,
      delta: 0,
    }
  },
  computed: {
    theValue() {
      return _get(this.Model.find(this.id), this.fieldName, 0)
    },
  },
  methods: {
    save() {
      if ('function' === typeof this.Model.updateModel) {
        if (this.value == this.stepperValue) return
        const fields = {
          [this.fieldName]: this.stepperValue,
          [this.deltaFieldName]: this.delta,
        }
        // @todo: update this stepper using an increment/decrement logic
        // let delta = this.value - this.stepperValue
        // console.log({ delta })
        this.Model.updateModel(this.id, fields)
      }
    }, // save
  },
}
</script>
